import { licenseStatusesSelectValues, occupationEcls } from '../../../../backend/constants';
import { useCredentialingTranslation } from '../../../../ui/hooks';
import { useFilterConfig } from '@juvare/common-data-table-ui/FiltersBar';
export function useLicenseCheckLatestStatusFilterConfig(userDisplayName) {
    const { t } = useCredentialingTranslation();
    return useFilterConfig((builder) => {
        const quickSearchFilter = builder.quickSearchFilter({
            dataPath: 'search',
            dataTest: 'toolbar-quick-search-input',
            label: t('common.search'),
            sx: { maxWidth: { xs: undefined, sm: 340 } },
        });
        const occupation = builder.quickFilterMultiSelect({
            label: t('table.credentialingVerification.occupation'),
            dataPath: 'occupationIds',
            dataTest: 'occupation-filter',
            widget: 'form.checkboxList',
            valueProvider: {
                type: 'classifier.occupation',
            },
            sx: { maxWidth: { xs: undefined, sm: 450 } },
        });
        const credentials = builder.quickFilterMultiSelect({
            label: t('table.credentialingVerification.credentialName'),
            dataPath: 'credentialNames',
            dataTest: 'credential-filter',
            widget: 'form.checkboxList',
            valueProvider: {
                type: 'classifier.occupationCredentialNames',
            },
            sx: { maxWidth: { xs: undefined, sm: 450 } },
        });
        const statuses = builder.quickFilterMultiSelect({
            label: t('table.credentialingVerification.status'),
            dataPath: 'statuses',
            dataTest: 'status-filter',
            widget: 'form.checkboxList',
            values: licenseStatusesSelectValues,
            sx: { maxWidth: { xs: undefined, sm: 450 } },
        });
        builder.allFiltersPanel({
            key: '!search',
            children: [quickSearchFilter],
        });
        builder.allFiltersPanel({
            label: t('table.credentialingVerification.filterLabels.identityInformation'),
            children: [
                builder.allFiltersWidget({
                    label: t('common.city'),
                    type: 'form.text',
                    key: 'city',
                }),
                builder.allFiltersWidget({
                    label: t('common.state'),
                    type: 'form.select',
                    key: 'state',
                    valueProvider: {
                        type: 'classifier.state',
                    },
                }),
                builder.allFiltersWidget({
                    type: 'form.select',
                    label: t('common.county'),
                    key: 'county',
                    valueProvider: {
                        type: 'classifier.county',
                        paramsFromFormData: 'state',
                    },
                }),
                builder.allFiltersWidget({
                    type: 'form.select',
                    key: 'tribeId',
                    label: t('common.tribe'),
                    valueProvider: {
                        type: 'classifier.tribe',
                    },
                }),
            ],
            style: {
                columns: 2,
            },
        });
        builder.allFiltersPanel({
            label: t('table.credentialingVerification.occupations'),
            children: [
                builder.allFiltersWidget({
                    label: t('table.credentialingVerification.filterLabels.selectType'),
                    key: 'occupationGroupId',
                    type: 'form.select',
                    valueProvider: {
                        type: 'classifier.occupationGroup',
                    },
                }),
                occupation,
                builder.allFiltersWidget({
                    type: 'form.divider',
                }),
                builder.allFiltersWidget({
                    key: 'ecls',
                    label: t('table.credentialingVerification.filterLabels.ecl'),
                    type: 'form.checkboxList',
                    values: occupationEcls,
                    style: {
                        layout: '2-columns-fit',
                    },
                }),
            ],
        });
        builder.allFiltersPanel({
            label: t('table.credentialingVerification.filterLabels.credential'),
            children: [
                builder.allFiltersWidget({
                    label: t('table.credentialingVerification.filterLabels.credentialCheckType'),
                    type: 'form.label',
                }),
                credentials,
                builder.allFiltersWidget({
                    type: 'form.divider',
                }),
                statuses,
            ],
        });
        builder.allFiltersPanel({
            label: t('table.credentialingVerification.requestDate'),
            children: [
                builder.allFiltersWidget({
                    label: t('table.credentialingVerification.filterLabels.loginAfter'),
                    type: 'form.dateTimePicker',
                    key: 'loginAfter',
                }),
                builder.allFiltersWidget({
                    label: t('table.credentialingVerification.filterLabels.loginBefore'),
                    type: 'form.dateTimePicker',
                    key: 'loginBefore',
                }),
            ],
        });
        builder.allFiltersPanel({
            label: t('table.credentialingVerification.requestedBy'),
            children: [
                builder.allFiltersWidget({
                    label: t('table.credentialingVerification.requestedBy'),
                    type: 'form.select',
                    key: 'requestedBy',
                    values: [
                        {
                            label: t('table.credentialingVerification.me'),
                            value: userDisplayName !== null && userDisplayName !== void 0 ? userDisplayName : '',
                        },
                        {
                            label: t('table.credentialingVerification.dailyVerificationSystem'),
                            value: 'System User',
                        },
                    ],
                }),
            ],
        });
    }, [t, userDisplayName]);
}
